export type DestroyOptions = { children?: boolean; texture?: boolean; baseTexture?: boolean; };
